import api from './api';

export const classificationService = {
  // ==================== CATEGORIES ====================
  
  async getCategories(params = {}) {
    const response = await api.get('/classification/categories', { params });
    return response.data;
  },
  
  async getCategory(id) {
    const response = await api.get(`/classification/categories/${id}`);
    return response.data;
  },
  
  async createCategory(data) {
    const response = await api.post('/classification/categories', data);
    return response.data;
  },
  
  async updateCategory(id, data) {
    const response = await api.put(`/classification/categories/${id}`, data);
    return response.data;
  },
  
  async deleteCategory(id) {
    const response = await api.delete(`/classification/categories/${id}`);
    return response.data;
  },
  
  // ==================== SUBCATEGORIES ====================
  
  async getSubcategories(params = {}) {
    const response = await api.get('/classification/subcategories', { params });
    return response.data;
  },
  
  async getSubcategory(id) {
    const response = await api.get(`/classification/subcategories/${id}`);
    return response.data;
  },
  
  async createSubcategory(data) {
    const response = await api.post('/classification/subcategories', data);
    return response.data;
  },
  
  async updateSubcategory(id, data) {
    const response = await api.put(`/classification/subcategories/${id}`, data);
    return response.data;
  },
  
  async deleteSubcategory(id) {
    const response = await api.delete(`/classification/subcategories/${id}`);
    return response.data;
  },
  
  // ==================== FAMILIES ====================
  
  async getFamilies(params = {}) {
    const response = await api.get('/classification/families', { params });
    return response.data;
  },
  
  async getFamily(id) {
    const response = await api.get(`/classification/families/${id}`);
    return response.data;
  },
  
  async createFamily(data) {
    const response = await api.post('/classification/families', data);
    return response.data;
  },
  
  async updateFamily(id, data) {
    const response = await api.put(`/classification/families/${id}`, data);
    return response.data;
  },
  
  async deleteFamily(id) {
    const response = await api.delete(`/classification/families/${id}`);
    return response.data;
  },
  
  // ==================== HIERARCHY ====================
  
  async getHierarchy(params = {}) {
    const response = await api.get('/classification/hierarchy', { params });
    return response.data;
  },
  
  // ==================== PRODUCT FORM DATA ====================
  
  async getProductFormData(params = {}) {
    const response = await api.get('/classification/product-form-data', { params });
    return response.data;
  },
};


